import React from 'react';
import SarasButton from '../../../../library/input/buttons/button/SarasButton';

const MONTH_STAT_CARD_WIDTH = 96;
const MONTH_ACTION_BUTTON_WIDTH = 34;

const CalMonthSummary = ({ month, monthSummary }) => {
    const statistics = Array.isArray(monthSummary?.statistics) ? monthSummary.statistics : [];
    const isLoading = !!monthSummary?.isLoading;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                flex: '0 1 auto',
                minWidth: 0
            }}
        >
            {statistics.map((statistic, index) => (
                <div
                    key={`${month.monthKey}_${statistic?.key || 'stat'}_${index}`}
                    title={statistic?.tooltip || ''}
                    style={{
                        width: `${MONTH_STAT_CARD_WIDTH}px`,
                        minWidth: `${MONTH_STAT_CARD_WIDTH}px`,
                        padding: '5px 8px',
                        border: '1px solid rgba(183, 198, 221, 0.85)',
                        borderRadius: '8px',
                        background: '#ffffff',
                        boxSizing: 'border-box'
                    }}
                >
                    <div
                        style={{
                            color: '#6a788e',
                            fontSize: '10px',
                            lineHeight: '11px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {statistic?.key || ''}
                    </div>
                    <div
                        style={{
                            color: '#33455f',
                            fontWeight: 700,
                            fontSize: '16px',
                            lineHeight: '17px',
                            marginTop: '3px'
                        }}
                    >
                        {statistic?.valF || ''}
                    </div>
                </div>
            ))}

            {statistics.length === 0 ? (
                <div
                    style={{
                        color: '#8a97aa',
                        fontSize: '12px',
                        lineHeight: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        minHeight: '32px'
                    }}
                >
                    {isLoading ? 'Loading summary...' : 'Summary pending'}
                </div>
            ) : null}

            <SarasButton
                onlyIcon
                starIcon="next"
                tooltip={`Open ${month.monthLabel} summary`}
                onClick={() => console.log('monthsummary action-click', { monthKey: month.monthKey })}
                className="uiMonthSummaryActionButton"
                starIconClassName="uiDefaultIconButton"
                style={{
                    width: `${MONTH_ACTION_BUTTON_WIDTH}px`,
                    minWidth: `${MONTH_ACTION_BUTTON_WIDTH}px`,
                    height: '34px',
                    border: '1px solid rgba(89, 113, 152, 0.22)',
                    borderRadius: '8px',
                    background: '#ffffff',
                    color: '#33455f',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            />
        </div>
    );
};

export default CalMonthSummary;
